<template>
    <ul class="footer__paysistems">
        <li style="width: 77px; height: 25px">
            <img src="@/assets/images/visa.svg" alt="Visa" />
        </li>
        <li style="width: 40px; height: 25px">
            <img src="@/assets/images/mastercard.svg" alt="Mastercard" />
        </li>
    </ul>
</template>

<script>
export default {};
</script>